// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"Articles_swiper-slide-active__dAgGg","wrapper":"Articles_wrapper__Ze75u","pagination":"Articles_pagination__i8Voy"};